// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_response_changeCurrentUserPassword(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "CurrentUserPasswordChanged",
    "InvalidCurrentPasswordError"
  ]);
}

let variablesConverter = {"changeCurrentUserPasswordInput":{},"__root":{"input":{"r":"changeCurrentUserPasswordInput"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {"__root":{"changeCurrentUserPassword":{"u":"response_changeCurrentUserPassword"}}};

let wrapResponseConverterMap = {
  response_changeCurrentUserPassword: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

let responseConverter = {"__root":{"changeCurrentUserPassword":{"u":"response_changeCurrentUserPassword"}}};

let responseConverterMap = {
  response_changeCurrentUserPassword: unwrap_response_changeCurrentUserPassword
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "message",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": null,
    "kind": "LinkedField",
    "name": "changeCurrentUserPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "CurrentUserPasswordChanged",
        "abstractKey": null
      },
      {
        "kind": "InlineFragment",
        "selections": (v1/*: any*/),
        "type": "InvalidCurrentPasswordError",
        "abstractKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PasswordSettings_ChangeCurrentUserPasswordMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PasswordSettings_ChangeCurrentUserPasswordMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "bafc1652556d233ec4b2a4af089185f3",
    "id": null,
    "metadata": {},
    "name": "PasswordSettings_ChangeCurrentUserPasswordMutation",
    "operationKind": "mutation",
    "text": "mutation PasswordSettings_ChangeCurrentUserPasswordMutation(\n  $input: ChangeCurrentUserPasswordInput!\n) {\n  changeCurrentUserPassword(input: $input) {\n    __typename\n    ... on CurrentUserPasswordChanged {\n      message\n    }\n    ... on InvalidCurrentPasswordError {\n      message\n    }\n  }\n}\n"
  }
};
})());

let wrap_response_changeCurrentUserPassword = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_changeCurrentUserPassword = unwrap_response_changeCurrentUserPassword;
exports.wrap_response_changeCurrentUserPassword = wrap_response_changeCurrentUserPassword;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
